import { createBrowserRouter, LoaderFunction, redirect } from 'react-router'
import App from '@/App'
import NotFound from '@/pages/errors/404'
import { ErrorBoundary } from '@/router/ErrorBoundary'
import { isDev } from '@/env'
import { H5DefaultLayout, LAYOUT, PcDedaultLayout, PERMISSIONS } from '@/layouts/constant'

/** 路由攔截 */
const loader: LoaderFunction = async ({ request, ...props }: any) => {
  if (isDev) await new Promise((res) => setTimeout(res, 100)) // 模擬網路延遲

  try {
    const pathname = '/home'
    const isLogin = true

    // 已登入不可訪問登入頁
    if (isLogin && pathname.includes('/login')) {
      redirect(`/home`)
      return {}
    }

    // 未登入需要先登入
    if (!isLogin) {
      redirect(`/login`)
      return {}
    }
  } catch {
    // ignore
  }
  // 不攔截
  return {}
}

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    loader,
    ErrorBoundary,
    children: [
      {
        index: true,
        lazy: async () => {
          const Component = await import('@/pages/home')
          return { Component: Component.default }
        },
        handle: {
          layout: PcDedaultLayout | H5DefaultLayout,
        },
      },
      {
        path: '/demo',
        lazy: async () => {
          const Component = await import('@/pages/demo')
          return { Component: Component.default }
        },
        handle: {
          layout: PcDedaultLayout | H5DefaultLayout,
        },
      },
      {
        path: '/about',
        lazy: async () => {
          const Component = await import('@/pages/about')
          return { Component: Component.default }
        },
        handle: {
          layout: LAYOUT.NONE,
          permissions: PERMISSIONS.NOT_LOGIN,
        },
      },
      {
        path: '/login',
        lazy: async () => {
          const Component = await import('@/pages/login')
          return { Component: Component.default }
        },
        handle: {
          layout: LAYOUT.NONE,
        },
      },
      {
        path: '/agent-management',
        lazy: async () => {
          const Component = await import('@/pages/agent-management')
          return { Component: Component.default }
        },
        handle: {
          layout: PcDedaultLayout | H5DefaultLayout,
        },
      },
      {
        path: '/player-management',
        lazy: async () => {
          const Component = await import('@/pages/player-management')
          return { Component: Component.default }
        },
        handle: {
          layout: PcDedaultLayout | H5DefaultLayout,
        },
      },
      {
        path: '/invitation-code-generator',
        lazy: async () => {
          const Component = await import('@/pages/invitation-code-generator')
          return { Component: Component.default }
        },
        handle: {
          layout: PcDedaultLayout | H5DefaultLayout,
        },
      },
      {
        path: '/station-report',
        lazy: async () => {
          const Component = await import('@/pages/station-report')
          return { Component: Component.default }
        },
        handle: {
          layout: PcDedaultLayout | H5DefaultLayout,
        },
      },
      {
        path: '/delegate-report',
        lazy: async () => {
          const Component = await import('@/pages/delegate-report')
          return { Component: Component.default }
        },
        handle: {
          layout: PcDedaultLayout | H5DefaultLayout,
        },
      },
      {
        path: '/player-report',
        lazy: async () => {
          const Component = await import('@/pages/player-report')
          return { Component: Component.default }
        },
        handle: {
          layout: PcDedaultLayout | H5DefaultLayout,
        },
      },
      {
        path: '/commission-report',
        lazy: async () => {
          const Component = await import('@/pages/commission-report')
          return { Component: Component.default }
        },
        handle: {
          layout: PcDedaultLayout | H5DefaultLayout,
        },
      },
      {
        path: '/funds-details',
        lazy: async () => {
          const Component = await import('@/pages/funds-details')
          return { Component: Component.default }
        },
        handle: {
          layout: PcDedaultLayout | H5DefaultLayout,
        },
      },
      {
        path: '/station-quota-change-log',
        lazy: async () => {
          const Component = await import('@/pages/station-quota-change-log')
          return { Component: Component.default }
        },
        handle: {
          layout: PcDedaultLayout | H5DefaultLayout,
        },
      },
      {
        path: '/recharge-list',
        lazy: async () => {
          const Component = await import('@/pages/recharge-list')
          return { Component: Component.default }
        },
        handle: {
          layout: PcDedaultLayout | H5DefaultLayout,
        },
      },
      {
        path: '/withdraw-list',
        lazy: async () => {
          const Component = await import('@/pages/withdraw-list')
          return { Component: Component.default }
        },
        handle: {
          layout: PcDedaultLayout | H5DefaultLayout,
        },
      },
      {
        path: '/kyc',
        lazy: async () => {
          const Component = await import('@/pages/kyc')
          return { Component: Component.default }
        },
        handle: {
          layout: PcDedaultLayout | H5DefaultLayout,
        },
      },
      {
        path: '/bet-record',
        lazy: async () => {
          const Component = await import('@/pages/bet-record')
          return { Component: Component.default }
        },
        handle: {
          layout: PcDedaultLayout | H5DefaultLayout,
        },
      },
      {
        path: '/sub-account-management',
        lazy: async () => {
          const Component = await import('@/pages/sub-account-management')
          return { Component: Component.default }
        },
        handle: {
          layout: PcDedaultLayout | H5DefaultLayout,
        },
      },
      {
        path: '/commission-withdrawal',
        lazy: async () => {
          const Component = await import('@/pages/commission-withdrawal')
          return { Component: Component.default }
        },
        handle: {
          layout: PcDedaultLayout | H5DefaultLayout,
        },
      },
      {
        path: '/update-password',
        lazy: async () => {
          const Component = await import('@/pages/update-password')
          return { Component: Component.default }
        },
        handle: {
          layout: PcDedaultLayout | H5DefaultLayout,
        },
      },
      {
        path: '/betting-bet-record',
        lazy: async () => {
          const Component = await import('@/pages/betting-bet-record')
          return { Component: Component.default }
        },
        handle: {
          layout: PcDedaultLayout | H5DefaultLayout,
        },
      },
      {
        path: '/station-exchange-record',
        lazy: async () => {
          const Component = await import('@/pages/station-exchange-record')
          return { Component: Component.default }
        },
        handle: {
          layout: PcDedaultLayout | H5DefaultLayout,
        },
      },
    ],
  },
  { path: '*', element: <NotFound /> },
])
